import { Col, Container, Row } from 'reactstrap'
import BecomeMember from './BecomeMember'
import Reviews from './Reviews'

const PricingContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <BecomeMember />
          <Reviews />
        </Col>
      </Row>
    </Container>
  )
}

export default PricingContainer